/**
 * Custom availability sorting for collection pages
 * Sorts products by:
 * 1. On the weekly menu and available
 * 2. Permanent products (in Cakes category)
 * 3. On the weekly menu but sold out
 * 4. Not available this week
 */

(function() {
  'use strict';

  // Get settings from theme settings or use defaults (weekly menu: product metafield custom.the_weekly_menu references Weekly Menu metaobject day entries; dynamic collections can reference the metaobject)
  const settingsElement = document.querySelector('script#availability-sort-settings');
  let cakesCategory = 'Cakes';
  let cakesCategoryHandle = 'cofetarie'; // Default handle for "Cakes"
  
  if (settingsElement) {
    try {
      const settings = JSON.parse(settingsElement.textContent);
      cakesCategory = settings.cakes_category || cakesCategory;
      cakesCategoryHandle = settings.cakes_category_handle || cakesCategoryHandle;
    } catch (e) {
      console.warn('Could not parse availability sort settings', e);
    }
  }
  
  // Ensure cakesCategoryHandle is set even if settings parsing failed
  if (!cakesCategoryHandle) {
    cakesCategoryHandle = cakesCategory.toLowerCase().trim().replace(/\s+/g, '-');
    // If still not set, use default
    if (!cakesCategoryHandle || cakesCategoryHandle === 'cakes') {
      cakesCategoryHandle = 'cofetarie';
    }
  }
  
  const customSortValue = 'availability';

  /**
   * Get product availability category
   * Returns: 1 = weekly menu available, 2 = permanent, 3 = weekly menu sold out, 4 = not available
   */
  function getProductAvailabilityCategory(productElement) {
    // Get product data from the product-card element (weekly menu from product metafield custom.the_weekly_menu referencing Weekly Menu metaobject; data-product-in-weekly-menu set by grid-view-item)
    const productCard = productElement.querySelector('product-card') || productElement;
    const productInWeeklyMenu = productCard.getAttribute('data-product-in-weekly-menu') === 'true';
    const productIsGiftCard = productCard.getAttribute('data-product-is-gift-card') === 'true';
    const productIsWorkshop = productCard.getAttribute('data-product-is-workshop') === 'true';
    const productCollectionHandles = productCard.getAttribute('data-product-collection-handles') || '';
    const productAvailable = productCard.getAttribute('data-product-available') === 'true';
    
    const collectionHandles = productCollectionHandles.split(',').map(c => c.trim()).filter(c => c);
    const isWeeklyMenu = productInWeeklyMenu;
    
    // Check if product is in Cakes category using handles (language-independent)
    // Use the handle from settings (converted from category name)
    const isInCakesCategory = collectionHandles.some(handle => {
      const handleLower = handle.toLowerCase().trim();
      // Check if handle matches the configured category handle
      return handleLower === cakesCategoryHandle;
    });
    
    // Determine category (workshop before weekly menu so stray metafield does not reclassify)
    if (productIsWorkshop || productIsGiftCard || isInCakesCategory) {
      return 2; // Gift cards, workshops, and permanent products (e.g. Cakes category)
    }
    if (isWeeklyMenu && productAvailable) {
      return 1; // On the weekly menu and available
    } else if (isWeeklyMenu && !productAvailable) {
      return 3; // On the weekly menu but sold out
    } else {
      return 4; // Not available this week
    }
  }

  /**
   * Sort products by availability
   */
  function sortProductsByAvailability(productGrid) {
    // Only sort product items, not other search result types (articles, pages, etc.)
    const allItems = Array.from(productGrid.querySelectorAll('.grid__item'));
    const productItems = allItems.filter(item => {
      const productCard = item.querySelector('product-card');
      return productCard !== null;
    });
    
    // Sort only product items
    productItems.sort((a, b) => {
      const categoryA = getProductAvailabilityCategory(a);
      const categoryB = getProductAvailabilityCategory(b);
      
      if (categoryA !== categoryB) {
        return categoryA - categoryB;
      }
      
      // If same category, maintain original order
      return 0;
    });
    
    // Get non-product items (articles, pages, etc.) to maintain their order
    const nonProductItems = allItems.filter(item => {
      const productCard = item.querySelector('product-card');
      return productCard === null;
    });
    
    // Remove all items from grid
    allItems.forEach(item => item.remove());
    
    // Re-append product items first (sorted), then non-product items
    productItems.forEach(product => {
      productGrid.appendChild(product);
    });
    nonProductItems.forEach(item => {
      productGrid.appendChild(item);
    });
  }

  /**
   * Add custom sort option to dropdowns as the first option
   */
  function addCustomSortOption() {
    const desktopSelect = document.querySelector('#SortBydesktop');
    const mobileSelect = document.querySelector('#SortBymobile');
    
    const customOption = document.createElement('option');
    customOption.value = customSortValue;
    customOption.textContent = 'Availability';
    
    // Check if option already exists
    if (desktopSelect && !desktopSelect.querySelector(`option[value="${customSortValue}"]`)) {
      // Insert as first option
      desktopSelect.insertBefore(customOption.cloneNode(true), desktopSelect.firstChild);
    }
    
    if (mobileSelect && !mobileSelect.querySelector(`option[value="${customSortValue}"]`)) {
      // Insert as first option
      mobileSelect.insertBefore(customOption.cloneNode(true), mobileSelect.firstChild);
    }
  }

  /**
   * Handle sort change
   */
  function handleSortChange(event) {
    const sortValue = event.target.value;
    
    if (sortValue === customSortValue) {
      // Prevent default form submission
      event.preventDefault();
      event.stopPropagation();
      
      // Find product grid
      const productGrid = document.querySelector('.collection-main-body-inner.product-grid--wrapper') ||
                         document.querySelector('#template--collection') ||
                         document.querySelector('.product-grid--wrapper');
      
      if (productGrid) {
        sortProductsByAvailability(productGrid);
        
        // Update URL without reloading
        const url = new URL(window.location);
        url.searchParams.set('sort_by', customSortValue);
        window.history.replaceState({}, '', url);
      }
    }
  }

  /**
   * Initialize
   */
  function init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    // Only run on collection or search pages
    const isCollectionPage = document.querySelector('[data-wetheme-section-type="template--collection"]');
    const isSearchPage = document.querySelector('[data-wetheme-section-type="template--search"]');
    
    if (!isCollectionPage && !isSearchPage) {
      return;
    }
    
    // Add custom sort option
    addCustomSortOption();
    
    // Listen for sort changes
    const desktopSelect = document.querySelector('#SortBydesktop');
    const mobileSelect = document.querySelector('#SortBymobile');
    
    if (desktopSelect) {
      desktopSelect.addEventListener('change', handleSortChange);
    }
    
    if (mobileSelect) {
      mobileSelect.addEventListener('change', handleSortChange);
    }
    
    // Check if custom sort is already selected on page load, or if no sort is specified (default)
    const urlParams = new URLSearchParams(window.location.search);
    const currentSort = urlParams.get('sort_by');
    
    // If no sort is specified or availability sort is selected, sort by availability
    if (!currentSort || currentSort === customSortValue) {
      // Set the dropdowns to availability sort
      if (desktopSelect) {
        desktopSelect.value = customSortValue;
      }
      if (mobileSelect) {
        mobileSelect.value = customSortValue;
      }
      
      // Sort the products
      const productGrid = document.querySelector('.collection-main-body-inner.product-grid--wrapper') ||
                         document.querySelector('#template--collection') ||
                         document.querySelector('.product-grid--wrapper');
      
      if (productGrid) {
        sortProductsByAvailability(productGrid);
        
        // Update URL to reflect the default sort
        if (!currentSort) {
          const url = new URL(window.location);
          url.searchParams.set('sort_by', customSortValue);
          window.history.replaceState({}, '', url);
        }
      }
    }
  }

  // Initialize
  init();
})();
